// extracted by mini-css-extract-plugin
module.exports = {"Hero":"styles_Hero__bLubj","bg_1":"styles_bg_1__aDXWP","height":"styles_height__kEeHU"};